import { buildAddressInputSchemas } from '../address/create-input.js';
import { CustomerAddressType } from './rules.js';
export { addressNameSchema, nameSchema } from '../address/create-input.js';
export const { createAddressInputSchema: createCustomerAddressInputSchema, typeIdSchema: customerAddressTypeIdSchema, } = buildAddressInputSchemas(CustomerAddressType, undefined, { requireFullAddress: true });
//# sourceMappingURL=create-input.js.map